import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { UseFormReturn } from "react-hook-form";

interface BaseProductFieldsProps {
  form: UseFormReturn<{
    name: string;
    quantity: string;
    unit: string;
    customUnit: string;
    price: string;
    minQuantity: string;
  }>;
  isPoultry?: boolean;
}

export const BaseProductFields = ({
  form,
  isPoultry = false,
}: BaseProductFieldsProps) => {
  const { register, watch, setValue } = form;
  const unit = watch("unit");
  const customUnit = watch("customUnit");

  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="name">{isPoultry ? "Race/Type de volaille" : "Nom du produit"}</Label>
        <Input
          id="name"
          {...register("name")}
          required
          placeholder={isPoultry ? "Ex: Poulet de chair" : "Nom du produit"}
        />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="quantity">Quantité</Label>
          <Input
            id="quantity"
            type="number"
            min="0"
            {...register("quantity")}
            required
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="minQuantity">Quantité minimum</Label>
          <Input
            id="minQuantity"
            type="number"
            min="0"
            {...register("minQuantity")}
            required
          />
        </div>
      </div>
      <div className="space-y-2">
        <Label htmlFor="unit">Unité</Label>
        {unit !== "custom" ? (
          <Select value={unit} onValueChange={(value) => setValue("unit", value)}>
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {isPoultry ? (
                <>
                  <SelectItem value="Tête">Tête</SelectItem>
                  <SelectItem value="Lot">Lot</SelectItem>
                  <SelectItem value="custom">Autre...</SelectItem>
                </>
              ) : (
                <>
                  <SelectItem value="Pièce">Pièce</SelectItem>
                  <SelectItem value="Carton">Carton</SelectItem>
                  <SelectItem value="Kg">Kg</SelectItem>
                  <SelectItem value="custom">Autre...</SelectItem>
                </>
              )}
            </SelectContent>
          </Select>
        ) : (
          <div className="flex gap-2">
            <Input
              {...register("customUnit")}
              placeholder="Entrez votre unité"
              required
            />
            <Button 
              type="button" 
              variant="outline"
              onClick={() => {
                setValue("unit", isPoultry ? "Tête" : "Pièce");
                setValue("customUnit", "");
              }}
            >
              Retour
            </Button>
          </div>
        )}
      </div>
      <div className="space-y-2">
        <Label htmlFor="price">Prix Unitaire (FCFA)</Label>
        <Input
          id="price"
          type="number"
          min="0"
          {...register("price")}
          required
        />
      </div>
    </>
  );
};